import Styles from './FacebookLoadingPreview.module.scss'
import { Skeleton } from 'components/Skeleton/Skeleton'

export const FacebookLoadingPreview = () => {
  return (
    <div className={Styles.facebookLoadingPreview}>
      <div className={Styles.header}>
        <Skeleton avatar={{ size: 38 }} active paragraph={{ rows: 2, width: 69 }} title={false} />
      </div>
      <div className={Styles.text}>
        <Skeleton
          active
          className={Styles.title}
          paragraph={{ rows: 3, width: 69, className: Styles.title }}
          title={false}
        />
      </div>
      <div className={Styles.body}></div>
      <div className={Styles.footer}>
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: 69 }} title={false} />
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: 69 }} title={false} />
        <Skeleton avatar={{ size: 24 }} active paragraph={{ rows: 1, width: 69 }} title={false} />
      </div>
    </div>
  )
}
